import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'cohrex-otp',
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OtpComponent implements OnInit {
  otps: string[] = [];
  maxLength = 1;

  @Input() otpLength: number = 6;
  @Output() otpChanged: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit(): void {
    this.otps = Array.from({ length: this.otpLength }, (v, i) => '');
  }

  onOTPEntered(event: KeyboardEvent) {
    let element;
    const target = event.target as HTMLInputElement;
    if (event.code !== 'Backspace') {
      element = (target.nextElementSibling ?? target) as HTMLInputElement;
    }

    if (event.code === 'Backspace') {
      element = target.previousElementSibling as HTMLInputElement;
      element?.select();
    }
    if (element == null) return;
    else {
      element.focus();
    }

    this.emitOTPValue();
  }

  onOTPPasted(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text');
    const otpInputs = document.getElementsByClassName('otp-input');
    for (let index = 0; index < otpInputs.length; index++) {
      const otpInput = otpInputs[index] as HTMLInputElement;
      otpInput.value = pastedText?.[index] ?? '';
      if (index === otpInputs.length - 1) {
        otpInput.focus();
      }
    }

    this.emitOTPValue();
  }

  emitOTPValue() {
    let otp = '';
    const otpInputs = document.getElementsByClassName(
      'otp-input'
    ) as unknown as HTMLInputElement[];
    for (const iterator of otpInputs) {
      otp += iterator.value;
    }
    this.otpChanged.emit(otp);
  }

  checkInputLength(event: Event) {
    const target = event.target as HTMLInputElement;

    if (target.value.length > this.maxLength) {
      target.value = target.value.slice(0, this.maxLength);
    }
  }
}
